import React from 'react'

import { TagSelect, components } from 'pharmacy/src/input/select'
import { nodeApiSearchItems } from 'mednet-util/src/search'

import css from './geoTagSelect.scss'

export class TopicOption extends React.Component {
  render() {
    const { topic, label, __isNew__ } = this.props.data

    if (__isNew__) {
      return (
        <components.Option {...this.props}>
          <div className={css.optionContainer}>{label}</div>
        </components.Option>
      )
    }

    return (
      <components.Option {...this.props}>
        <div className={css.optionContainer}>{topic}</div>
      </components.Option>
    )
  }
}

// Resolves only the newest call in the debounce window; superseded calls never
// settle, so the select's loading state always tracks the latest keystroke.
const makeDebouncedTopicSearch = (limit) => {
  let timer
  const search = (query) =>
    new Promise((resolve) => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        nodeApiSearchItems('topics', { query, limit })
          .then((data) => resolve(data.items))
          .catch((error) => {
            console.error(error)
            resolve([])
          })
      }, 200)
    })
  search.cancel = () => clearTimeout(timer)
  return search
}

class TopicTagSelect extends React.Component {
  constructor(props) {
    super(props)
    this.state = { inputValue: '' }
    this.loadOptions = makeDebouncedTopicSearch(props.hitsPerPage || 5)
  }

  componentWillUnmount() {
    this.loadOptions.cancel()
  }

  handleInputChange = (value) => {
    this.setState({ inputValue: value })
  }

  getOptionValue = (datum) => {
    return datum.topicId || datum.label
  }

  getOptionLabel = (datum) => {
    return datum.topic || datum.label
  }

  render() {
    const { hitsPerPage, ...restProps } = this.props

    return (
      <TagSelect
        async
        components={{ Option: TopicOption }}
        getOptionLabel={this.getOptionLabel}
        getOptionValue={this.getOptionValue}
        loadOptions={this.loadOptions}
        menuIsOpen={Boolean(this.state.inputValue)}
        name="topic[]"
        onInputChange={this.handleInputChange}
        placeholder="Select..."
        {...restProps}
      />
    )
  }
}

export default TopicTagSelect
